import React, {useEffect} from 'react';
import {styles} from "./index";

import {HeadlineTitleText} from "@/app/components/texts";
import {useTranslation} from "react-i18next";
import {s} from "@/app/utils/s";
import Space, {spaceSizes} from "@/app/components/Space";
import Divider from "@/app/components/divider";
import Checkbox from "@/app/components/checkbox";
import {MarketingAuthStatusEnum, NonSubstitutedMedicinesEnum} from "@/app/api/medicines";
import {enumValues} from "@/app/utils/custom_function";
import useMedicines from "@/app/features/home/components/medicines/slice";
import ButtonText from "@/app/components/button_text";
import {TransitionGroup} from "react-transition-group";
import CustomCssTransition from "@/app/components/custom_css_transition";
import Tip from "@/app/components/tips";
import SearchInput from "@/app/components/search_input";
import MedicineItem from "@/app/features/home/components/medicines/medicine_item";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import EmptyPage from "@/app/components/empty_page";

const MedicinesPage = () => {
  const {t} = useTranslation();
  const {state, toggleAuthStatus, toggleNonSubstitutedMedicines, cleanAllFilters, search, goToMedicineDetail} = useMedicines();

  useEffect(() => {
    search("", true);
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.filters}>
        <TransitionGroup component={null}>
          <CustomCssTransition
            inProp={state.filters.length !== 0}
            withHeight={true}>
            <div className={styles.filters__your_chose}>
              <div className={styles.filters__your_chose__title}>
                <HeadlineTitleText text={t(s.yourChose)}/>
                <ButtonText onChange={() => cleanAllFilters()}>{t(s.cleanAll)}</ButtonText>
              </div>
              <Space h={spaceSizes.s20}/>
              <div className={styles.filters__your_chose__tips}>
                <TransitionGroup component={null}>
                  {state.filters.map((s) => (
                    <CustomCssTransition
                      key={s}  // add a unique key
                      inProp={state.filters.includes(s)}
                      withHeight={true}
                    >
                      <Tip>{t(s)}</Tip>
                    </CustomCssTransition>
                  ))}
                </TransitionGroup>
              </div>
              {/*{state.nonSubstitutedMedicines.map((s) => <Tip children={t(s)}/>)}*/}
              {/*{state.marketingAuthorizationStatus.map((s) => <Tip children={t(s)}/>)}*/}
            </div>
          </CustomCssTransition>
          <Space h={spaceSizes.s20}/>
          <HeadlineTitleText text={t(s.marketingAuthorizationStatus)}/>
          <Space h={spaceSizes.s20}/>
          <Divider/>
          <Space h={spaceSizes.s20}/>
          <Checkbox<MarketingAuthStatusEnum> items={enumValues(MarketingAuthStatusEnum)}
                                             onChange={(s) => toggleAuthStatus(s)} useS={true}/>
          <Space h={spaceSizes.s28}/>
          <HeadlineTitleText text={t(s.nonSubstitutedMedicines)}/>
          <Space h={spaceSizes.s20}/>
          <Divider/>
          <Space h={spaceSizes.s20}/>
          <Checkbox<NonSubstitutedMedicinesEnum> items={enumValues(NonSubstitutedMedicinesEnum)}
                                                 onChange={(s) => toggleNonSubstitutedMedicines(s)} useS={true}/>
        </TransitionGroup>
      </div>
      <div className={styles.main}>
        {state.hasLoading ? (
          <CircularProgressIndicator/>
        ) : (
          <>
            <SearchInput onChange={(value) => search(value)}/>
            <Space h={spaceSizes.s28}/>
            <div className={styles.medicines}>
              {state.medicines.map((medicine) => (
                <MedicineItem item={medicine} key={medicine.id} onClick={(id) => goToMedicineDetail(id)}/>
              ))}
              {state.medicines.length === 0 && (<EmptyPage/>)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MedicinesPage;